"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./pixelated.table.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
class Table extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: []
    };
    this.state.tableData = this.props.data;
  }
  getHeadings(data) {
    const headings = Object.keys(data[0]).map((key, i) => {
      return /*#__PURE__*/_react.default.createElement("th", {
        key: i
      }, key);
    });
    return /*#__PURE__*/_react.default.createElement("tr", null, headings);
  }
  getRows(data) {
    return data.map((obj, i) => {
      return /*#__PURE__*/_react.default.createElement("tr", {
        key: i
      }, this.getCells(obj));
    });
  }
  getColumnCount(data) {
    return Object.keys(data[0]).length;
  }
  getCells(obj) {
    return Object.values(obj).map((value, i) => {
      return /*#__PURE__*/_react.default.createElement("td", {
        key: i
      }, value);
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("table", {
      className: "pixTable"
    }, /*#__PURE__*/_react.default.createElement("thead", null, this.getHeadings(this.state.tableData)), /*#__PURE__*/_react.default.createElement("tbody", null, this.getRows(this.state.tableData))));
  }
}
exports.Table = Table;
_defineProperty(Table, "propTypes", {
  data: _propTypes.default.array
});